/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

import store from '@/store';
	
CKEDITOR.plugins.add('basicstyles', {
	init(editor){
		var addButtonCommand = function( buttonName, commandName, styleDefiniton ) {
				// Disable the command if no definition is configured.
				if (!styleDefiniton){
					return;
				}

				let style = new CKEDITOR.style(styleDefiniton);
				let forms = contentForms[commandName];

				// add style to the start of the forms array
				forms.unshift(style);
				

				// Listen to contextual style activation.
				editor.attachStyleStateChange( style, (state)=>{
					if(editor.getCommand(commandName).setState(state)){
						store.dispatch('paperEdit/ck/toolbarSetButtonState', {
							commandName,
							editorType: editor.$ckEditorType,
							state,
						});
					}
				});

				// Create the command that can be used to apply the style.
				editor.addCommand(commandName, new CKEDITOR.styleCommand(style, {
					contentForms: forms
				}));

				// Register the button, if the button plugin is loaded.
				if (editor.ui.addButton) {
					editor.ui.addButton( buttonName, {
						label: buttonName,
						command: commandName,
					});
				}
			};

		let contentForms = {
			bold: [
				'strong',
				'b',
				['span', (el)=>{
					let fw = el.styles['font-weight'];
					return fw == 'bold' || +fw >= 700;
				}]
			],

			italic: [
				'em',
				'i',
				['span', (el)=>{
					return el.styles[ 'font-style' ] == 'italic';
				}]
			],

			underline: [
				'u',
				['span', (el)=> {
					return el.styles[ 'text-decoration' ] == 'underline';
				}]
			],

			strike: [
				's',
				'strike',
				['span', (el)=>{
					return el.styles[ 'text-decoration' ] == 'line-through';
				}]
			],

			subscript: [
				'sub'
			],

			superscript: [
				'sup'
			]
		}

		addButtonCommand( 'Bold', 'bold', editor.config.coreStyles_bold );
		addButtonCommand( 'Italic', 'italic', editor.config.coreStyles_italic );
		addButtonCommand( 'Underline', 'underline', editor.config.coreStyles_underline );
		addButtonCommand( 'Strike', 'strike', editor.config.coreStyles_strike );
		addButtonCommand( 'Subscript', 'subscript', editor.config.coreStyles_subscript );
		addButtonCommand( 'Superscript', 'superscript', editor.config.coreStyles_superscript );

		editor.setKeystroke( [
			[ CKEDITOR.CTRL + 66 /*B*/, 'bold' ],
			[ CKEDITOR.CTRL + 73 /*I*/, 'italic' ],
			[ CKEDITOR.CTRL + 85 /*U*/, 'underline' ]
		] );
	}
});

// Basic Inline Styles.

/**
 * The style definition that applies the **bold** style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		config.coreStyles_bold = { element: 'b', overrides: 'strong' };
 *
 *		config.coreStyles_bold = {
 *			element: 'span',
 *			attributes: { 'class': 'Bold' }
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_bold = { element: 'strong', overrides: 'b' };

/**
 * The style definition that applies the *italics* style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		config.coreStyles_italic = { element: 'i', overrides: 'em' };
 *
 *		CKEDITOR.config.coreStyles_italic = {
 *			element: 'span',
 *			attributes: { 'class': 'Italic' }
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_italic = { element: 'em', overrides: 'i' };

/**
 * The style definition that applies the <u>underline</u> style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		CKEDITOR.config.coreStyles_underline = {
 *			element: 'span',
 *			attributes: { 'class': 'Underline' }
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_underline = { element: 'u' };

/**
 * The style definition that applies the <strike>strikethrough</strike> style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		CKEDITOR.config.coreStyles_strike = {
 *			element: 'span',
 *			attributes: { 'class': 'Strikethrough' },
 *			overrides: 'strike'
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_strike = { element: 's', overrides: 'strike' };

/**
 * The style definition that applies the subscript style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		CKEDITOR.config.coreStyles_subscript = {
 *			element: 'span',
 *			attributes: { 'class': 'Subscript' },
 *			overrides: 'sub'
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_subscript = { element: 'sub' };

/**
 * The style definition that applies the superscript style to the text.
 *
 * Read more in the {@glink features/basicstyles documentation}
 * and see the {@glink examples/basicstyles example}.
 *
 *		CKEDITOR.config.coreStyles_superscript = {
 *			element: 'span',
 *			attributes: { 'class': 'Superscript' },
 *			overrides: 'sup'
 *		};
 *
 * @cfg
 * @member CKEDITOR.config
 */
CKEDITOR.config.coreStyles_superscript = { element: 'sup' };
